import { render, staticRenderFns } from "./livePhysicianItem.vue?vue&type=template&id=483c4cf5&scoped=true"
import script from "./livePhysicianItem.vue?vue&type=script&lang=js"
export * from "./livePhysicianItem.vue?vue&type=script&lang=js"
import style0 from "./livePhysicianItem.vue?vue&type=style&index=0&id=483c4cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c4cf5",
  null
  
)

export default component.exports